import { AuthFrame } from '../../components/cloud/SignIn.tsx';

/**
 * Public, signed out: how to delete a Mojo Up AI Cloud account and what goes with it. Facebook Login
 * requires a page like this (its "data deletion instructions URL"); Google and Apple reviewers ask too.
 */
export function AccountDeletionPage() {
  return (
    <AuthFrame title="Deleting your AI Cloud account" blurb="How to delete your account, and what is deleted with it." footer="Mojo Up AI Cloud keeps its data in Australia.">
      <div className="grid gap-4 text-sm leading-relaxed">
        <section className="grid gap-1.5">
          <h2 className="font-semibold">Delete it yourself</h2>
          <ol className="ml-5 list-decimal grid gap-1 text-muted">
            <li>
              Sign in at{' '}
              <a className="text-accent underline" href="/">
                cloud.mojoup.ai
              </a>{' '}
              with any of your sign-in methods.
            </li>
            <li>Open Settings, then Delete your account.</li>
            <li>Type your email address to confirm, then choose Delete account.</li>
          </ol>
          <p className="text-muted">If you are the only owner of a team that has other people in it, make someone else an owner first.</p>
        </section>
        <section className="grid gap-1.5">
          <h2 className="font-semibold">What is deleted</h2>
          <p className="text-muted">
            Your account, every way you sign in (including a Facebook, Google, Microsoft or GitHub link), and your personal organisation with its projects, memory, backups and records. Teams where you
            are the only person are deleted too. You leave every other team; what you added to a team stays with that team.
          </p>
        </section>
        <section className="grid gap-1.5">
          <h2 className="font-semibold">Ask us instead</h2>
          <p className="text-muted">
            If you cannot sign in, email{' '}
            <a className="text-accent underline" href="mailto:privacy@mojoup.com.au">
              privacy@mojoup.com.au
            </a>{' '}
            from the address on your account. We confirm it is you and delete it within 30 days. Read our{' '}
            <a className="text-accent underline" href="https://mojoup.ai/privacy">
              privacy policy
            </a>
            .
          </p>
        </section>
      </div>
    </AuthFrame>
  );
}
